import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
import { BorderTop, BorderBottom } from '../../../src/styled/shared-styles';
import { Z_INDEXES } from '../../../src/styled/global-variables';
import { SETTINGS_WIDTH, SIDEBAR_DIRECTORY_WIDTH } from './style-constants';
export const Wrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
`;
export const WrapperTable = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ $withSidebarDirectory }) => $withSidebarDirectory ? `calc(100% - ${SIDEBAR_DIRECTORY_WIDTH})` : '100%'};
  min-width: ${getSizeBy(125)};
`;
export const SettingsContainer = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${Z_INDEXES.TABLE_HEADER + 2};
  width: ${({ $active }) => ($active ? SETTINGS_WIDTH : '0')};
  overflow: hidden;
  background: ${getColor('surface')};
  box-shadow:
    inset 1px 0 0 0 ${getColorShade('onSurface', 'border')},
    inset -1px 0 0 0 ${getColorShade('onSurface', 'border')};
  ${BorderTop}
  ${BorderBottom}
  transition: width 0.3s ease-out;
  will-change: width;
`;
export const SidebarDirectoryContainer = styled.div `
  width: ${SIDEBAR_DIRECTORY_WIDTH};
  min-width: ${SIDEBAR_DIRECTORY_WIDTH};
  height: 100%;
  transition: all 0.3s ease-out;
  will-change: width;
`;
export const TableIsEmpty = styled.div.attrs({ className: 'no-data-message' }) `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  & > svg {
    margin-bottom: ${getSizeBy(6.5)};
  }
`;
